import { signal } from "@preact/signals-react";
import { FlowStep, OutComes, SurfaceMessage } from "../types";
import React from "react";

type ChatBody = {
  bot: boolean;
  element: string | React.ReactNode;
  jsonObject?: { [key: string]: unknown };
  isOpenAI?: boolean;
  displayOnly?: boolean;
  id?: string;
};

class MessageBroker extends EventTarget {
  constructor() {
    super();
  }

  sendMessage(message: SurfaceMessage) {
    this.dispatchEvent(new CustomEvent("message", { detail: message }));
  }
}

export const conversationState = signal<ChatBody[] | []>([]);
export const isBotTyping = signal<boolean>(false);
export const appId = signal("");
export const flowId = signal("");
export const stepId = signal("Welcome");
export const connectionId = signal("");
export const botData = signal<FlowStep[]>([]);
export const outcomes = signal<OutComes | null>(null);
export const userInput = signal("");
export const userId = signal("0011D000017fwFRQAY");
export const isAgentTransferAvailable = signal(false);
export const disableInput = signal(false);
export const messageBroker = signal(new MessageBroker());
export const isOcrForm = signal<boolean | undefined>(false);
export const ocrProcessingComplete = signal<boolean>(false);
export const ocrProcessingMatches = signal<boolean>(false);
export const faceLivenessComplete = signal<boolean>(false);
export const currentAppBrandingClass = signal<string>("");
export const hasLoadedSettings = signal<boolean>(false);
// sales
export const affinityToken = signal<string | null>(null);
export const identifier = signal<string | null>(null);
export const websocket = signal<WebSocket | null>(null);

export const addToConversation = async (payload: ChatBody) => {
  // check for duplicate message IDs
  for (const message of conversationState.value) {
    if (payload.id && message.id && payload.id === message.id) {
      console.log("addToConversation duplicate message, skipping", {
        existingMessage: message,
        newMessage: payload,
      });
      console.log("addToConversation the IDs", {
        existingMessage: message.id,
        newMessage: payload.id,
      });
      // message is duplicate, bail out
      return;
    }
  }

  // console.log("addToConversation::", JSON.stringify(payload));
  payload.displayOnly =
    payload.displayOnly == null || payload.displayOnly == undefined
      ? false
      : payload.displayOnly;

  const messages = [...conversationState.value, payload];
  // sort messages chronologically by timestamp with oldest first
  messages.sort((a, b) => {
    const aTime = a.jsonObject?.timestamp as number;
    const bTime = b.jsonObject?.timestamp as number;
    return aTime - bTime;
  });

  conversationState.value = messages;

  if (!payload.bot && !payload.displayOnly) {
    removeHTMLFromConversation();
    if (websocket.value) {
      isBotTyping.value = true;
      websocket.value.send(
        JSON.stringify({
          message: payload.element,
          data: payload.jsonObject?.action || "",
        })
      );
    }
  }
}; //AsyncProcessHandler - Websocket message event.

export const publishToBackend = async (payload: ChatBody) => {
  payload.displayOnly =
    payload.displayOnly == null || payload.displayOnly == undefined
      ? false
      : payload.displayOnly;
  console.log("publishToBackend::", payload);
  if (websocket.value && !payload.displayOnly) {
    websocket.value.send(
      JSON.stringify({
        message: payload.element,
        data: payload.jsonObject?.action || "",
      })
    );
  }
};

export const removeHTMLFromConversation = () => {
  conversationState.value = [
    ...conversationState.value.filter(
      (e) => typeof e.element === "string" || e.isOpenAI === true
    ),
  ];
};
